/**
 * Entry-point into simple
 */
import { useEffect } from 'react';
import { useLoaderData, useParams } from 'react-router';
import { useHotkeys } from 'react-hotkeys-hook';
import { useDispatch, useSelector } from 'react-redux';
import useMobileDetect from './useMobileDetect';
import Body from './Body';
import Header from './Header';
import Modal from '../../components/Modal/index';
import { actionToggleWidget } from '../../actions/layout';
import { actionShowModal } from '../../actions/modal';
import { ModalTypes } from '../../reducers/modal';
import Notifs from '../../components/Notifications';
import { actionSwitchCurrent } from '../../actions/current';
import Loader from '../../components/common/Loader';
import AdblockChecker from '../../components/AdblockModal';
import { IStore } from '../../reducers';
import MobileBody from './mobile';
import './styles.scss';
import { currentLoaderDataType } from '../loaders/cexCurrentLoader';
import { actionChangePrimaryTicker } from '../../actions/grid';
import TransactionsStatus from '../../components/TransactionsStatus';

interface urlParams {
  // dex case
  chain?: string;
  address?: string;
  // cex case
  exchange?: string;
  base?: string;
  quote?: string;
  // wallet case
  wallet?: string;
  timeframe?: string;
}

// Brain of main page
const MainPage = () => {
  const { isMobile, isDesktop } = useMobileDetect();
  // const loading = useSelector((state: IStore) => state.current.loading);
  const layout = useSelector((state: IStore) => state.layout);
  const params: urlParams = useParams();
  const dispatch = useDispatch();
  const ticker = useLoaderData() as currentLoaderDataType;

  /**
   * Open tickers window
   */
  useHotkeys('cmd+p', (e: any) => {
    e.preventDefault();
    dispatch(actionShowModal(ModalTypes.tickers, {}));
  });
  /**
   * Open search window
   */
  useHotkeys('cmd+f', (e: any) => {
    e.preventDefault();
    dispatch(actionShowModal(ModalTypes.tickers, {}));
  });
  /**
   * Open full screen
   */
  useHotkeys('cmd+k+f', (e: any) => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    }
  });

  /**
   * Handle specific links
   */
  useEffect(() => {
    if (params.timeframe && params.wallet && params.address && params.chain) {
      dispatch(
        actionShowModal(ModalTypes.wallet, {
          timeframe: params.timeframe,
          wallet: params.wallet,
          address: params.address,
          chain: params.chain,
        })
      );
    } else if (params.timeframe && params.wallet) {
      dispatch(
        actionShowModal(ModalTypes.walletPairs, {
          timeframe: params.timeframe,
          wallet: params.wallet,
        })
      );
    }
  }, []);

  useEffect(() => {
    if (ticker) {
      const newTicker = {
        base_precision: 2,
        ...ticker,
        base: ticker.name.split('/')[0],
        quote: ticker.name.split('/')[1],
        id: Number(ticker.id),
      };
      dispatch(actionSwitchCurrent(newTicker));
      dispatch(
        actionChangePrimaryTicker({ ticker, exchange: ticker.exchange })
      );
    }
  }, [dispatch, ticker]);

  if (isMobile) {
    return (
      <div className='main_page'>
        <MobileBody />
        {/* {loading && (
          <div className='main_page__backdrop'>
            <Loader className='main_page__backdrop__loader' />
          </div>
        )} */}
      </div>
    );
  }

  return (
    <div className='main_page'>
      <Header />
      <Body
        isWatchlistVisible={layout.watchlist}
        isChartVisible={layout.chart}
        isTradesVisible={layout.trades}
        isTradingVisible={layout.trading}
        isInfoVisible={layout.info}
        onChange={(a, b) => dispatch(actionToggleWidget(a, b))}
      />
      <Modal />
      <Notifs />
      <TransactionsStatus />
      <AdblockChecker />
      {/* {loading && (
        <div className='main_page__backdrop'>
          <Loader className='main_page__backdrop__loader' />
        </div>
      )} */}
    </div>
  );
};

export default MainPage;
